import React, { Component } from "react";
import { Table, List, Confirm, Icon, Button } from "semantic-ui-react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import Moment from "moment";
import PhotoEditingJob from "~/models/PhotoEditing/PhotoEditingJob";
import JobStatus from "~/constants/PhotoEditing/JobStatus";
import Link from "~/components/element/Link";
import EstimatedTime from "../../components/EstimatedTime";

@observer
class JobsTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openConfirm: false,
      photoEditingJobId: 0,
    };
  }

  onDeletePhotoEditingJobClick(photoEditingJobId) {
    this.setState({ photoEditingJobId, openConfirm: true });
  }

  onCancel() {
    this.setState({ photoEditingJobId: 0, openConfirm: false });
  }

  /**
   * Do remove the image
   */
  onConfirm() {
    const { deletePhotoEditingJobCallback } = this.props;
    const { photoEditingJobId } = this.state;

    // close the confirm while we delete the image in the background.
    this.setState({ photoEditingJobId: 0, openConfirm: false });

    return deletePhotoEditingJobCallback(photoEditingJobId);
  }

  render() {
    const { photoEditingJobs, hasProviderColumn, hideTourColumn, hideContinueButton, viewJobCallback } = this.props;
    const { openConfirm, photoEditingJobId } = this.state;

    return (
      <div>
        <Confirm
          open={openConfirm}
          header="Warning"
          content={`Job #${photoEditingJobId} and all its images will be deleted. Do you want to continue?`}
          onCancel={() => this.onCancel()}
          onConfirm={() => this.onConfirm()}
        />
        <Table celled padded textAlign="center" columns={5}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Job</Table.HeaderCell>
              {hasProviderColumn ? <Table.HeaderCell>Provider</Table.HeaderCell> : null}
              {hideTourColumn ? null : <Table.HeaderCell>Tour #</Table.HeaderCell>}
              <Table.HeaderCell>Status</Table.HeaderCell>
              <Table.HeaderCell>ETA</Table.HeaderCell>
              <Table.HeaderCell>Label</Table.HeaderCell>
              <Table.HeaderCell>View</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {photoEditingJobs.length === 0 ? (
              <Table.Row>
                <Table.Cell colSpan={hasProviderColumn ? 7 : 6} textAlign="center">
                  <Icon name="search" />
                  <span>No Results</span>
                </Table.Cell>
              </Table.Row>
            ) : null}
            {photoEditingJobs.map(photoEditingJob => (
              <Table.Row key={photoEditingJob.photoEditingJobId}>
                <Table.Cell>
                  <strong>{photoEditingJob.typeLabel}</strong>
                  <br />
                  {(() => {
                    if (photoEditingJob.photoEditingImages.length > 1) {
                      return `${photoEditingJob.photoEditingImages.length} images`;
                    }

                    if (photoEditingJob.photoEditingImages.length === 1) {
                      return `1 image`;
                    }

                    return `No images`;
                  })()}
                  <br />
                  <br />
                  <div className="help-text">
                    Job ID: {photoEditingJob.photoEditingJobId}
                    <br />
                    Creation Date: {Moment(photoEditingJob.creationDts).format("MM/DD/YYYY HH:mm")}
                  </div>
                </Table.Cell>
                {hasProviderColumn ? (
                  <Table.Cell>
                    {photoEditingJob.provider.providerId} <br /> {photoEditingJob.provider.name}
                  </Table.Cell>
                ) : null}
                {hideTourColumn ? null : <Table.Cell>{photoEditingJob.tourId}</Table.Cell>}
                <Table.Cell>{photoEditingJob.statusLabel}</Table.Cell>
                <Table.Cell>
                  {/* Do not show ETA if job is in creation */}
                  {photoEditingJob.isStatusInCreation ? null : <EstimatedTime photoEditingJob={photoEditingJob} />}
                </Table.Cell>
                <Table.Cell>
                  <List>
                    {photoEditingJob.photoEditingLabels.map(photoEditingLabel => (
                      <List.Item key={photoEditingLabel.photoEditingLabelId}>{photoEditingLabel.name}</List.Item>
                    ))}
                  </List>
                </Table.Cell>
                <Table.Cell verticalAlign="middle">
                  <Button.Group size="tiny" vertical>
                    {(() => {
                      if (photoEditingJob.status !== JobStatus.IN_CREATION) {
                        return (
                          <Link
                            as={Button}
                            color="blue"
                            onClick={viewJobCallback ? () => viewJobCallback(photoEditingJob) : null}
                            to={`/${photoEditingJob.photoEditingJobId}`}
                          >
                            view
                          </Link>
                        );
                      }

                      if (hideContinueButton) {
                        return null;
                      }

                      const pathAction =
                        photoEditingJob.status === JobStatus.IN_CREATION &&
                        photoEditingJob.photoEditingImages.length > 0
                          ? "images"
                          : "upload";

                      return (
                        <Link
                          as={Button}
                          color="blue"
                          to={`/${photoEditingJob.photoEditingJobId}/${pathAction}`}
                          onClick={viewJobCallback ? () => viewJobCallback(photoEditingJob) : null}
                        >
                          continue
                        </Link>
                      );
                    })()}
                    {photoEditingJob.status === JobStatus.IN_CREATION ? (
                      <Button
                        color="red"
                        onClick={() => this.onDeletePhotoEditingJobClick(photoEditingJob.photoEditingJobId)}
                      >
                        delete
                      </Button>
                    ) : (
                      ""
                    )}
                  </Button.Group>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </div>
    );
  }
}

JobsTable.propTypes = {
  photoEditingJobs: PropTypes.arrayOf(PropTypes.instanceOf(PhotoEditingJob)),
  hideTourColumn: PropTypes.bool,
  hideContinueButton: PropTypes.bool,
  hasProviderColumn: PropTypes.bool,
  deletePhotoEditingJobCallback: PropTypes.func.isRequired,
  // passed if outside the scope of react-router
  viewJobCallback: PropTypes.func,
};

JobsTable.defaultProps = {
  hideTourColumn: false,
  hideContinueButton: false,
  hasProviderColumn: false,
};

export default JobsTable;
